import { atom, useAtom } from "jotai";

const currentClip = atom<string | number | null>(null);

export const useCurrentClip = () => useAtom(currentClip);
